import React, { memo, useMemo } from "react"
import Divider from "@material-ui/core/Divider"
import Box from "@material-ui/core/Box"
import { groupArray } from "@/utils"
import ParticipantNoRoleList from "./participant-no-role-list"
import TopContent from "./top-content"

const ControlPanelContent = memo((props) => {
    const { projectRolesRetrieve, participants } = props

    const participantHaveRolesGroupedByRole = useMemo(() => {
        return participants.haveRole.length && groupArray(participants.haveRole, "roleId", {})
    }, [participants])

    const participantNoRolesGroupedByRole = useMemo(() => {
        return participants.noRole
    }, [participants])

    return (
        <Box className="detail">
            {projectRolesRetrieve.projectRoles.length && (
                <TopContent
                    projectRolesRetrieve={projectRolesRetrieve}
                    participantHaveRolesGroupedByRole={participantHaveRolesGroupedByRole}
                />
            )}
            <Divider />
            <ParticipantNoRoleList participantNoRolesGroupedByRole={participantNoRolesGroupedByRole} />
        </Box>
    )
})

export default ControlPanelContent
